import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./directives";
import "./filters";

import Vue2TouchEvents from "vue2-touch-events";
import VueTheMask from "vue-the-mask";

Vue.config.productionTip = false;
require("leaflet/dist/leaflet.css");
require("vue2-daterange-picker/src/assets/daterangepicker.css");
require("vue-slider-component/theme/default.css");
// eslint-disable-next-line
delete L.Icon.Default.prototype._getIconUrl;
// eslint-disable-next-line
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

Vue.use(Vue2TouchEvents, {
  touchClass: "",
  tapTolerance: 10,
  swipeTolerance: 30,
  longTapTimeInterval: 400
});
Vue.use(VueTheMask);

router.beforeEach((to, from, next) => {
  // возможно поменять
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;

  if (!store.state.regionAreas) {
    store.dispatch("getRegionAreas");
  }

  if (!store.state.isAuthorized && !store.state.hasCheckedProfile) {
    store.dispatch("getUser").then(res => {
      if (res.status === 403) {
        console.log(res.status);
      }
      next();
    });
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
